import { Injectable } from "@angular/core";
import { NotificationService } from "@progress/kendo-angular-notification";
import Swal from 'sweetalert2';

export enum notifyType {
  Info = 1,
  Error = 2,
  Warning = 3,
}

interface AlertConfig {
  text: string;
  type: notifyType;
  isCancelButton?: boolean;
  isYesButton?: string;
  isNoButton?: string;
  header?: string;
  width?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotifyService {

  result: any;
  dismissResult: any = 'cancel';

  constructor(private readonly notificationService: NotificationService) { }

  success(text) {
    this.notificationService.show({
      content: text,
      cssClass: "button-notification",
      animation: { type: "slide", duration: 400 },
      position: { horizontal: "right", vertical: "top" },
      type: { style: "success", icon: true },
    });
  }

  info(text) {
    this.notificationService.show({
      content: text,
      cssClass: "button-notification",
      animation: { type: "slide", duration: 400 },
      position: { horizontal: "right", vertical: "top" },
      type: { style: "info", icon: true },
    });
  }

  alertpopover(config: AlertConfig) {
    return new Promise((resolve) => {
      const isCancelButton = config.isCancelButton !== false;
      const isYesButton = config.isYesButton ? config.isYesButton : 'Ok';
      const isNoButton = config.isNoButton ? config.isNoButton : 'Cancel';
      let iconHtml = '';
      switch (config.type) {
        case 1:
          iconHtml = `
                    <div class="swal2-icon swal2-info swal2-icon-show" style="display: flex;">
                        <div class="swal2-icon-content">i</div>
                    </div>
                `;
          break;
        case 2:
          iconHtml = `
                    <div class="swal2-icon swal2-error swal2-icon-show" style="display: flex;">
              <div class="swal2-x-mark">
                <div class="swal2-x-mark-line-left"></div>
                <div class="swal2-x-mark-line-right"></div>
              </div>
            </div>
                `;
          break;
        case 3:
          iconHtml = `
            <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
              <div class="swal2-icon-content">!</div>
            </div>
                `;
          break;
      }
      Swal.fire({
        html: `
        <div style="max-height: 80vh;">
          <div class="model d-flex flex-column align-items-center justify-content-center">
            <div class="modal__logo mt-2">
              <img src="assets/images/nextere-black.png" alt="" height="35" class="w-80">
            </div>
            ${iconHtml}
            ${config.header ? `<h3 class="modal__title mt-2 text-center">${config.header}</h3>` : ''}
            ${config.text ? `<p class="modal__message mt-2 text-center" style="font-size:18px">${config.text}</p>` : ''}
            <div class="d-flex gap-2 mt-2">
              <button id="confirmOk" class="btn btn-primary">${isYesButton}</button>
              ${isCancelButton ? `<button id="confirmCancel" class="btn btn-light">${isNoButton}</button>` : ''}
            </div>
          </div>
          </div>
        `,
        icon: undefined,
        showConfirmButton: false,
        showCancelButton: false,
        width: config?.width,
        didOpen: () => {
          const container = Swal.getHtmlContainer();
          if (container) {
            container.scrollTop = 0;
          }
          document.getElementById("confirmOk").addEventListener("click", () => {
            Swal.close();
            resolve(true);
          });

          if (isCancelButton) {
            document.getElementById("confirmCancel").addEventListener("click", () => {
              Swal.close();
              resolve(false);
            });
          }
        },
      });
    });
  }
}